module.exports = __webpack_public_path__ + "images/673af6587915fc55f24c6fb4d52938e5.png";